/**
 * Video playlist entry.
 */

// JS Component Framework and component configurations.
import { ComponentManager } from 'js-component-framework';
import videoPlaylistFactoryConfig from 'components/video-playlist-factory';
import videoPlaylistConfig from 'components/video-playlist';
import domContentLoaded from 'utils/domContentLoaded';

import 'components/video-playlist/video-playlist.scss';

// Anvato player manager and player components.
import AnvatoPlayerManager from 'components/anvato-player-manager';

const componentManager = new ComponentManager('nexstar');
const initComponents = () => {
  componentManager.initComponents([
    videoPlaylistFactoryConfig,
    videoPlaylistConfig,
  ]);
};

// Initialize components.
domContentLoaded(() => {
  initComponents();
});

if (module.hot) {
  module.hot.accept();
  // This is required for HMR.
  initComponents();
}

/*
 * Boot the manager for Anvato player instances.
 */

// Ensure the main anvp global is set.
window.anvp = window.anvp || {};

const anvatoPlayerManager = new AnvatoPlayerManager(
  window.anvp,
  window.amScripts.page_attributes,
  window.amScripts.bob.base_host,
);

/**
 * Listen for new players, and ensure they're registered with the manager. This
 * will run every time a new player is instantiated or an existing player is
 * "reloaded" by calling `window.loadAnvato()` again with new parameters.
 */
window.anvp.onReady = () => {
  anvatoPlayerManager.getAndSetUpAll();
};
